import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: {
        borderRadius: '8px',
        borderWidth: '1px',
        paddingLeft: '24px',
        paddingRight: '24px',
        fontWeight: 700,
        fontSize: '14px',
        height: '40px',
        textTransform: 'none',
    } as SxProps<Theme>,
};
